module.exports = __webpack_public_path__ + "static/together_bg01-17ac4e0b919621c48469fb7ef3e9fa36.png";